<template>
  <div id="app">
    <!-- <van-image fit="fill" :src="sysImageUrl" width="100%" height="30px" /> -->
    <van-notice-bar :text="sysAnnounce" left-icon="volume-o" />
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(item, index) in newsArray" :key="index" @click="changetoPage(index)">
        <!-- <img
          v-lazy="item.image"
          style="width:100%;height:200px;"
          v-on:
        /> -->
        <van-image width="100%" height="150px" fit="scale-down" :src=item.image lazy-load  />

        <h4 class="title">
          <span>{{ item.title }} </span>
        </h4>
      </van-swipe-item>
    </van-swipe>

    <van-grid :column-num="3" style="margin-top:10px; margin-bottom:10px">
      <van-grid-item to="/articlelist/infos">
         <template slot="icon">
          <svg class="custom-icon" aria-hidden="true">
            <use xlink:href="#icon-tongzhigonggao"></use>
          </svg>
        </template>
        <template slot="text">
          <span class="custom-text">工会资讯</span>
        </template>
      </van-grid-item>
      <van-grid-item to="/articlelist/organize">
         <template slot="icon">
          <svg class="custom-icon" aria-hidden="true">
            <use xlink:href="#icon-zuzhijiagou"></use>
          </svg>
        </template>
        <template slot="text">
          <span class="custom-text">组织架构</span>
        </template>
      </van-grid-item>
      <van-grid-item to="/articlelist/class">
         <template slot="icon">
          <svg class="custom-icon" aria-hidden="true">
            <use xlink:href="#icon-gongzuoliucheng"></use>
          </svg>
        </template>
        <template slot="text">
          <span class="custom-text">班组信息</span>
        </template>
      </van-grid-item>
      <van-grid-item to="/articlelist/createinfo">
         <template slot="icon">
          <svg class="custom-icon" aria-hidden="true">
            <use xlink:href="#icon-zhishichanquan"></use>
          </svg>
        </template>
        <template slot="text">
          <span class="custom-text">岗位创新</span>
        </template>
      </van-grid-item>
      <van-grid-item to="/articlelist/worksprite">
         <template slot="icon">
          <svg class="custom-icon" aria-hidden="true">
            <use xlink:href="#icon-huodongbanshou"></use>
          </svg>
        </template>
        <template slot="text">
          <span class="custom-text">工匠精神</span>
        </template>
      </van-grid-item>
      <van-grid-item to="/articlelist/womansprite">
         <template slot="icon">
          <svg class="custom-icon" aria-hidden="true">
            <use xlink:href="#icon-nvxing-guanliyuan"></use>
          </svg>
        </template>
        <template slot="text">
          <span class="custom-text">巾帼风采</span>
        </template>
      </van-grid-item>

    </van-grid>

    <div class="header-1">
      <h2>今日工会</h2>
    </div>

    <ul>
      <li v-for="(onenew, index) in newsArray" :key="index">
        <a v-on:click="changetoPage(index)"
          ><!-- :href="onenew.link" -->
          <div class="tag">{{ onenew.type }}</div>
          {{ onenew.title }}
        </a>
      </li>
    </ul>

    <div class="header-1">
      <h2>我的信箱</h2>
    </div>

    <ul class="margin-bottom-20">
      <li style=" float: left;width:50%">
        <a
          href="#/leavemessage"
          target="_blank"
          title="留言信箱"
          style="text-align: center; 
          background:#fef8f1;
          color:#c50001;
          margin: 0 10px;
          padding: 12px 0;"
          ><svg
            class="icon"
            aria-hidden="true"
            style="font-size:18px;margin-right:10px;"
          >
            <use xlink:href="#icon-185078emailmailstreamline"></use>
          </svg>
          留言信箱</a
        >
      </li>
      <li style=" float: left;width:50%">
        <a
          href="#/suggestion"
          target="_blank"
          title="系统建议"
          style="text-align: center; 
          background:#fef8f1;
          color:#c50001;
          margin: 0 10px;
          padding: 12px 0;"
        >
          <svg
            class="icon"
            aria-hidden="true"
            style="font-size:18px;margin-right:10px;"
          >
            <use xlink:href="#icon-suggestion"></use>
          </svg>
          系统建议</a
        >
      </li>
    </ul>

    <br /><br /><br /><br /><br /><br />
    <mTabbar></mTabbar>
  </div>
</template>

<script>
import mTabbar from "../components/TabBar";
import store from "../store";
import axios from "axios";
import $ from "jquery";

import Vue from "vue";
import { Swipe, SwipeItem, Row, Col, Icon, Cell, CellGroup, Toast, Grid, GridItem, Image as VanImage, Lazyload } from "vant";

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Toast)
  .use(Row)
  .use(Col)
  .use(Icon)
  .use(Cell)
  .use(CellGroup)
  .use(Grid)
  .use(GridItem)
  .use(VanImage)
  .use(Lazyload);

import { NoticeBar } from "vant";

Vue.use(NoticeBar);

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    mTabbar,
  },
  data() {
    return {
      ifAddLoginPoint: false,
      sysAnnounce: "这里是通知内容滚动播出的地方",
      pointLogin: 0,
      // sysImageUrl: "",
      newsArray: [],
    };
  },
  created: function() {
    this.getSysConfig();
  },
  mounted: function() {},
  methods: {
    getSysConfig() {
      let APIBASEURL = "https://www.gongdiangonghui.cn";
      var _this = this;
      axios
        .get(APIBASEURL + "/sysconfig/getSysConfig")
        .then(function(response) {
          // response = JSON.parse(response);
          //alert("成功，结果是:" + JSON.stringify(response.data));
          if (response.data.code == "200") {
            // _this.sysImageUrl = response.data.data.sysImageUrl;
            _this.sysAnnounce = response.data.data.sysAnnounce;
            _this.pointLogin = response.data.data.pointLogin;
            _this.getUserListNews();
          } else {
            alert("getSysConfig失败，原因是: " + response.data.msg);
          }
        })
        .catch(function(error) {
          alert("getSysConfig失败，原因是: " + error);
        });
    },
    getUserListNews() {
      let APIBASEURL = "https://www.gongdiangonghui.cn";

      // var postdata = {
      //   jwt: store.state.jwt
      // };
      // AJAX请求默认参数
      // $.ajaxSetup({
      //   type: "POST",
      //   dataType: "json",
      //   timeout: 3000,
      //   beforeSend: function (request) {
      //     request.setRequestHeader("Content-Type", "application/json; charset=utf-8");
      //   }
      // });
      const _this = this;
      $.ajax({
        cache: false,
        contentType: "application/json",
        dataType: "json",
        type: "POST",
        url:
          APIBASEURL +
          "/newsIndex/userListNewsIndex?page=0&pageSize=20&onlyIndex=true",
        data: JSON.stringify({
          jwt: store.state.jwt, //  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJvTTJyTDVrOEdLRGV6NkwtMk16NElwYkhGd1VVIiwiaXNzIjoiYXV0aDAifQ.iJuawLanz3ORrmtUNmp4A_tp9xVZplQiGR_Dye6AECs"
        }),
        async: false,
        // beforeSend: function (XMLHttpRequest) {
        //				XMLHttpRequest.setRequestHeader("authorization", storage["yuekejwt"]);
        //			},
        error: function(request) {
          alert("userListNewsIndex发送请求失败" + request);
        },
        success: function(response) {
          // alert("成功，response是:" + JSON.stringify(response) );
          if (response.code != "200") {
            //alert("提示：" + response.msg);
            if (response.msg == "no user info related weixin") {
              alert("提示：请重新打开链接，允许授权获得微信头像用户名。");
              _this.$router.push("/registry");
            } else if (response.msg == "bad user info Status:0") {
              alert("提示：未注册成功，请重新注册。");
              _this.$router.push("/registry");
            } else if (response.msg == "bad user info Status:2") {
              alert("提示：没有找到人员信息或者不在组织人员激活名单内，请注册或者联系管理员。");
              _this.$router.push("/registry");
            }else if (response.msg == "no such user") {
              alert("提示：未注册成功，没有找到相关人员信息。");
              _this.$router.push("/registry");
            } else {
              alert("userListNewsIndex返回错误信息" + response.msg);
            }
          } else {
            if (response.data.ifAddLoginPoint) {
              _this.$toast({
                message: "今日签到成功，用户积分加 " + _this.pointLogin + " 分",
              });
            }
            _this.newsArray = response.data.newsIndexList.content;
            _this.$forceUpdate();
          }
        },
      });
    },
    changetoPage: function(index) {
      // alert("index is"+this.newsArray[index].contentType+"..."+this.newsArray[index].contentid);
      let APIBASEURL = "https://www.gongdiangonghui.cn";
      var _this = this;
      if (this.newsArray[index].contentType == "2") {
        //{label:"文章",value:0},{label:"文档",value:1},{label:"外链",value:2},{label:"活动",value:3}
        $.ajax({
          cache: false,
          contentType: "application/json",
          dataType: "json",
          type: "POST",
          url: APIBASEURL + "/link/userGetLink",
          data: JSON.stringify({
            jwt: store.state.jwt, //  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJvTTJyTDVrOEdLRGV6NkwtMk16NElwYkhGd1VVIiwiaXNzIjoiYXV0aDAifQ.iJuawLanz3ORrmtUNmp4A_tp9xVZplQiGR_Dye6AECs",

            id: _this.newsArray[index].contentid,
          }),
          async: false,
          error: function(request) {
            alert("发送请求失败" + request);
          },
          success: function(response) {
            // alert("成功，response是:" + JSON.stringify(response) );
            if (response.code != "200") {
              alert("返回错误信息" + response.msg);
            } else {
              // alert("成功，getlink response是:" +response.data.linkurl );
              window.location.href = response.data.linkurl;
            }
          },
        });
      } else if (this.newsArray[index].contentType == "0") {
        //带着文章id，跳转到新页面
        this.$router.push("/blankarticle/" + _this.newsArray[index].contentid);
      } else if (this.newsArray[index].contentType == "3") {
        //带着活动id，跳转到新页面
        this.$router.push("/blankactivity/" + _this.newsArray[index].contentid);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.van-search {
  padding-top: 6px;
  padding-bottom: 4px;
}

.custom-icon{
  height: 40px;
  width: 40px;
}

.header-1 {
  border-bottom: 0;
  border-bottom-color: currentcolor;
  border-bottom-style: none;
  border-bottom-width: 0px;
  overflow: hidden;
}

.header-1 h2 {
  color: #de371c;
  font-size: 18px;
  border-left: 3px solid #de371c;
  padding-left: 15px;
  font-weight: 700;
  margin: 10px 10px;
  text-align: left;
}

li {
  margin: 0;
  list-style-type: none;
  padding-left: 5px;
  font-size: 16px;
  line-height: 1;
  padding-top: 12px;
  padding-bottom: 12px;
}

li a {
  margin-left: 0;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  width: 90%;
  vertical-align: bottom;
  margin-left: -10px;
  color: #333;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}

li a .tag {
  float: left;
  border-right: 1px solid #ddd;
  margin-right: 10px;
  padding-right: 10px;
}
</style>
